import React from 'react';
import { ArrowRight } from 'lucide-react';
import { specialMomentsContent, siteInfo, galleryImages } from '../data/mock';

const SpecialMomentsSection = () => {
  const handleWhatsApp = () => {
    const message = encodeURIComponent(
      `Hola Luciana, me gustaría información sobre tus servicios de maquillaje para un evento especial. ¡Gracias!`
    );
    window.open(`https://wa.me/${siteInfo.whatsapp}?text=${message}`, '_blank');
  };

  // Get an image for this section
  const sectionImage = galleryImages.find(img => img.category === 'social') || galleryImages[0];

  return (
    <section id="momentos-especiales" className="section-padding bg-[#fffef2]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div>
            <p className="hero-subtitle text-[#666] mb-4">
              Servicios
            </p>
            <h2 className="section-title text-[#333] mb-8">
              {specialMomentsContent.title}
            </h2>
            <p className="body-large text-[#666] leading-relaxed mb-10">
              {specialMomentsContent.description}
            </p>

            {/* CTA */}
            <button
              onClick={handleWhatsApp}
              className="btn-primary group"
            >
              {specialMomentsContent.cta}
              <ArrowRight size={16} className="ml-2 transition-transform group-hover:translate-x-1" />
            </button>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/5] overflow-hidden">
              <img
                src={sectionImage.src}
                alt="Momentos especiales - Luciana Belén"
                className="w-full h-full object-cover img-hover"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -top-4 -left-4 w-32 h-32 border border-[#bcbbb4] -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecialMomentsSection;
